import { type Dispatch, type SetStateAction, createContext } from 'react';
import { type PricingRules } from '@gql/schema';

export interface FinalRates {
  show: boolean;
  cheapestFinalRate: string;
  cheapestFinalRatePerRoomPerNight: string;
  // This comes from the useFlightState hook and should always align
  flightsSelected: boolean;
  // Temporary way to access values - ideally should align state across app
  numberOfTravellers: number;
  numberOfNights: number;
}

export interface IAppStateContext {
  saleId: string;
  pricingRules: PricingRules;
  isSemiLoggedUser: boolean;
  isStaffUser: boolean;
  hasCredits: boolean;
  showPricingAndAvailability: boolean;
  showAds: boolean;
  warningMessageBody?: string;
  finalRates: FinalRates;
  setFinalRates: Dispatch<SetStateAction<FinalRates>>;
  onOpenLeadForm?: () => void;
  onOpenPasswordLoginForm?: () => void;
  previewMode: boolean;
}

export const AppStateContext = createContext<IAppStateContext | undefined>(undefined);
